import { loader } from "@monaco-editor/react";

/**
 * Configures the Monaco editor loader to use a specific version of the editor.
 * because @monaco-editor/react by default loads monaco editor from a CDN.
 *
 * Should match the version in package.json.
 *
 * Future work: look into self-hosting Monaco and lazy load it when the user
 * reaches the code editor for the first time.
 */
export function configureMonaco() {
  loader.config({
    paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.55.1/min/vs" },
  });
}
